import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterProjeto(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/apoios/projetos/${projetoId}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesas(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/apoios/etapas/${etapaId}/despesas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(etapaId, despesaId) {
        return axiosJwt
            .get(`${api}/sgtec/apoios/etapas/${etapaId}/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
